export default {
  noticeApi: {
    mail: {
      findActive: '/api/notice/mail/findActive',
      save: '/api/notice/mail/save',
      sendMail: '/api/notice/mail/sendMail'
    },
    sms: {
      findActive: '/api/notice/sms/findActive',
      save: '/api/notice/sms/save',
    },
  }

}